import { render, staticRenderFns } from "./ExamRecord.vue?vue&type=template&id=4e566466&"
import script from "./examRecord.js?vue&type=script&lang=js&"
export * from "./examRecord.js?vue&type=script&lang=js&"
import style0 from "./examRecord.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports